import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/LoginImproved";
import Dashboard from "./pages/DashboardImproved";
import Vehicles from "./pages/Vehicles";
import VehicleDetails from "./pages/VehicleDetailsImproved";
import Invoices from "./pages/InvoicesImproved";
import CreateInvoice from "./pages/CreateInvoiceImproved"; // Single invoice page
import CreateBulkInvoice from "./pages/CreateBulkInvoice"; // Bulk invoice page
import Payments from "./pages/PaymentsImproved";
import CollectPayment from "./pages/CollectPayment"; // Collect payment page
import WriteOffs from "./pages/WriteOffsImproved";
import CreateWriteOffPage from "./pages/CreateWriteOffPageImproved"; // ✅ New page
import Reports from "./pages/ReportsPageImproved";
import MonthlyCollectionReport from "./pages/MonthlyCollectionReport";
// import VehicleLedgerReport from "./pages/VehicleLedgerReport";
// import StaffPerformanceReport from "./pages/StaffPerformanceReport";
// import WriteOffReport from "./pages/WriteOffReport";
// import OutstandingDuesReport from "./pages/OutstandingDuesReport";
import ProtectedRoute from "./components/ProtectedRoute";
import RegisterVehicle from "./pages/RegisterVehicle";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/vehicles" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
        <Route path="/vehicles/:id" element={<ProtectedRoute><VehicleDetails /></ProtectedRoute>} />
        <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
        <Route path="/create-invoice/:vehicleId" element={<ProtectedRoute><CreateInvoice /></ProtectedRoute>} />
        <Route path="/create-bulk-invoice" element={<ProtectedRoute><CreateBulkInvoice /></ProtectedRoute>} />
        <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
        <Route path="/payments/collect/:id" element={<ProtectedRoute><CollectPayment /></ProtectedRoute>} />
        <Route path="/writeoffs" element={<ProtectedRoute><WriteOffs /></ProtectedRoute>} />
        <Route path="/writeoffs/create/:id" element={<ProtectedRoute><CreateWriteOffPage /></ProtectedRoute>} /> {/* ✅ New route */}


        {/* Reports */}
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/reports/monthly-collection" element={<ProtectedRoute><MonthlyCollectionReport /></ProtectedRoute>} />
        {/* <Route path="/reports/vehicle-ledger" element={<ProtectedRoute><VehicleLedgerReport /></ProtectedRoute>} /> */}
        {/* <Route path="/reports/staff-performance" element={<ProtectedRoute><StaffPerformanceReport /></ProtectedRoute>} /> */}
        {/* <Route path="/reports/writeoff" element={<ProtectedRoute><WriteOffReport /></ProtectedRoute>} /> */}
        {/* <Route path="/reports/outstanding-dues" element={<ProtectedRoute><OutstandingDuesReport /></ProtectedRoute>} /> */}

        <Route path="/register-vehicle" element={<ProtectedRoute><RegisterVehicle /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
